import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Slide from '@material-ui/core/Slide';
import DialogContentText from '@material-ui/core/DialogContentText';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import active_lang from 'src/langs/jp_en';
import firebase from 'firebase/app';
import 'firebase/firestore';
import useUpdateStadiumInfo from 'src/hooks/useUpdateStadiumInfo';
import { useSnackbar } from 'notistack';
import { ENQUEUE_SUCCESS_CONFIG } from 'src/consts/ENQUEUE_CONFIG';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function UploadFileDialog({
  open,
  setOpen,
  stadium_info,
  files,
  index,
  refetch,
}) {
  const { enqueueSnackbar } = useSnackbar();
  let mutationUpdateStadiumInfo = useUpdateStadiumInfo();
  const [file, setFile] = useState(null);

  const handleClose = () => {
    setOpen(prevState => {
      const newState = [...prevState];
      newState[index] = false;
      return newState;
    });
  };

  const handleFileChange = event => {
    const file = event.target.files[0];
    if (file) {
      setFile(file);
    }
  };

  const handleUpload = () => {
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async e => {
      const text = e.target.result;

      const splitCSVLine = line => {
        const result = [];
        let cur = '';
        let inQuotes = false;
        for (let i = 0; i < line.length; i++) {
          const ch = line[i];
          if (ch === '"') {
            if (inQuotes && line[i + 1] === '"') {
              cur += '"';
              i++;
            } else {
              inQuotes = !inQuotes;
            }
          } else if (ch === ',' && !inQuotes) {
            result.push(cur);
            cur = '';
          } else {
            cur += ch;
          }
        }
        result.push(cur);
        return result;
      };

      try {
        const lines = text.split(/\r\n|\n/).filter(l => l.trim() !== '');
        if (lines.length < 2) {
          console.warn('CSV contains no data rows');
        }

        const headers = splitCSVLine(lines[0]).map(h => h.trim());
        const normalizedHeaders = headers.map(h =>
          h
            .replace(/\./g, '')
            .trim()
            .toLowerCase()
        );
        const identifierIndex = normalizedHeaders.indexOf('identifier');
        if (identifierIndex === -1) {
          return;
        }

        const db = firebase.firestore();
        let seatsCollectionName = 'data';
        try {
          const stadiumDoc = await db
            .collection('stadium_manage')
            .doc(String(stadium_info.id))
            .get();
          const stadiumData = stadiumDoc.exists ? stadiumDoc.data() : null;
          if (
            stadiumData &&
            stadiumData.cms_settings &&
            stadiumData.cms_settings.pre_order === true
          ) {
            seatsCollectionName = 'data_2026';
          }
        } catch (err) {
          console.error('Failed to read stadium_manage doc:', err);
        }

        const baseColl = db
          .collection('stadium_manage_seats')
          .doc(String(stadium_info.id))
          .collection(seatsCollectionName);

        const BATCH_LIMIT = 500;
        let batch = db.batch();
        let batchCount = 0;

        for (let i = 1; i < lines.length; i++) {
          const values = splitCSVLine(lines[i]);
          const obj = {};
          for (let j = 0; j < headers.length; j++) {
            const rawHeader = headers[j];
            const norm = rawHeader
              .replace(/\./g, '')
              .trim()
              .toLowerCase();
            if (norm === 'no') continue;

            const normalizedKey = rawHeader
              .trim()
              .toLowerCase()
              .replace(/\s+/g, '_');
            const rawValue = values[j] !== undefined ? values[j] : '';
            const trimmed = String(rawValue).trim();
            if (/^[yY]$/.test(trimmed)) {
              obj[normalizedKey] = true;
            } else if (/^[nN]$/.test(trimmed)) {
              obj[normalizedKey] = false;
            } else {
              obj[normalizedKey] = rawValue;
            }
          }

          const identifier = values[identifierIndex];
          if (!identifier) {
            continue;
          }

          const docRef = baseColl.doc(String(identifier));
          batch.set(docRef, obj);
          batchCount++;

          if (batchCount >= BATCH_LIMIT) {
            await batch.commit();
            batch = db.batch();
            batchCount = 0;
          }
        }

        if (batchCount > 0) {
          await batch.commit();
        }

        await db
          .collection('stadium_manage_seats')
          .doc(String(stadium_info.id))
          .set(
            { updatedAt: firebase.firestore.FieldValue.serverTimestamp() },
            { merge: true }
          );

        mutationUpdateStadiumInfo.mutateAsync({
          rest_id: stadium_info.id,
          payload: { seats_saved: true },
        });
        setFile(null);
        setOpen(false);
        enqueueSnackbar(
          active_lang.RESTAURANT_CONFIG_UPDATE_SUCCESS,
          ENQUEUE_SUCCESS_CONFIG
        );
        refetch();
      } catch (error) {
        console.error('Save parsed CSV to Firestore failed:', error);
      }
    };

    reader.onerror = err => {
      console.error('File read error:', err);
    };

    reader.readAsText(file);
  };

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        maxWidth={'lg'}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          <Grid container>
            <Grid item md={12} style={{ textAlign: 'center' }}>
              <Box>Upload File</Box>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <CardContent
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                gap: '8px',
              }}
            >
              <input
                accept=".csv"
                style={{ display: 'none' }}
                id="contained-button-file"
                type="file"
                onChange={handleFileChange}
              />
              <label
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingBottom: '8px',
                }}
                htmlFor="contained-button-file"
              >
                <Button variant="contained" color="primary" component="span">
                  Upload CSV File
                </Button>
              </label>
              {(files[index].length > 0 || file) && (
                <Typography
                  variant="body2"
                  style={{ textAlign: 'center', marginTop: '10px' }}
                >
                  {stadium_info.id}.csv
                </Typography>
              )}
              <Button
                variant="contained"
                color="primary"
                onClick={handleUpload}
                disabled={!file}
                style={{ marginTop: '10px' }}
              >
                Upload to Firebase
              </Button>
            </CardContent>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {active_lang.ADMIN_USER_UPDATE_CANCEL}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
